import SiteHeader from "../../components/feature/SiteHeader";
import SiteFooter from "../../components/feature/SiteFooter";
import usePageTitle from "../../hooks/usePageTitle";
import Hero from "./components/Hero";
import EpisodePreview from "./components/EpisodePreview";
import AnalysisHighlights from "./components/AnalysisHighlights";
import ThemeZones from "./components/ThemeZones";
import ViewingGuide from "./components/ViewingGuide";
import EndingBanner from "./components/EndingBanner";
import Faq from "./components/Faq";
import AboutBand from "./components/AboutBand";

export default function Home() {
  usePageTitle();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "守护甜心动漫分集剧情｜全集剧情解析与结局详解",
    description:
      "甜心剧情站汇总守护甜心动漫全部分集剧情、每集剧情速览与结局剧情解析，从第一集到最终话按顺序梳理。",
    url: "https://sequelio.github.io/",
    inLanguage: "zh-CN",
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <SiteHeader />
      <main>
        <Hero />
        <EpisodePreview />
        <AnalysisHighlights />
        <ThemeZones />
        <ViewingGuide />
        <EndingBanner />
        <Faq />
        <AboutBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}

function BackToTop() {
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-colors hover:bg-primary-600"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line" />
    </button>
  );
}